import { render, staticRenderFns } from "./UbahKlinik.vue?vue&type=template&id=0730d554&"
import script from "./UbahKlinik.vue?vue&type=script&lang=js&"
export * from "./UbahKlinik.vue?vue&type=script&lang=js&"
import style0 from "./UbahKlinik.vue?vue&type=style&index=0&scope=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports